export const Slider = {
  defaultProps: {
    colorScheme: 'upgrade.blue',
  },
  baseStyle: {
    track: {
      height: '1.5',
      borderRadius: 'sm',
    },
    thumb: {
      border: '1.5px solid',
      borderColor: 'gray.200',
      height: 4,
      width: 4,

      _hover: {
        borderColor: 'upgrade.blue.500',
      },
      _focus: {
        borderColor: 'gray.200',
      },
    },
  },
};
